<!-- Contenedor principal. -->
<div id="qsigner-container">
  <!-- Loading general. -->
  <div id="loading-data" class="qsigner-loading" *ngIf="loadingData">
    <div class="spiner-example">
      <!-- Texto para mostrar. -->
      <div class="text-center">
        <h1>{{ 'GETTING_INFORMATION' | translate }}</h1>
      </div>
      <!-- Spinner. -->
      <div class="sk-spinner sk-spinner-three-bounce">
        <div class="sk-bounce1"></div>
        <div class="sk-bounce2"></div>
        <div class="sk-bounce3"></div>
      </div>
    </div>
  </div>

  <!-- Contenedor principal. -->
  <div class="container-data animated fadeInDown m-t" *ngIf="!loadingData">
    <!-- Contenido. -->
    <div id="container-data-content">
      <!-- Título. -->
      <div class="text-center">
        <h1 class="">QSigner</h1>
      </div>

      <hr />

      <!-- Firmas y autorizaciones. -->
      <div class="col-md-12 text-center" [ngStyle]="{ 'pointer-events': !blockBody === false ? 'none' : 'auto', opacity: !blockBody === false ? '0.4' : '1' }">
        <div id="content-all">
          <!-- Bloque para el título pincipal.  -->
          <div class="text-center" class="pb-4">
            <h2>
              <ng-container *ngIf="documentos && documentos.signatures">
                {{ 'SIGNER.SIGNS' | translate }}
              </ng-container>
              <ng-container *ngIf="documentos && documentos.authorization && documentos.signatures">
                {{ 'SIGNER.AND' | translate }}
              </ng-container>
              <ng-container *ngIf="documentos && documentos.authorization && documentos.signatures">
                {{ 'SIGNER.AUTHORIZATIONS' | translate }}
              </ng-container>
              <ng-container *ngIf="documentos && documentos.authorization && !documentos.signatures">
                {{ 'SIGNER.MAYUS_AUTHORIZATIONS' | translate }}
              </ng-container>
            </h2>
            <!-- Resume -->
            <p>
              {{ 'SIGNER.HAS_TOTAL' | translate }}
              <ng-container *ngIf="documentos && documentos.signatures">
                <strong>{{ documentos.signatures.length }}</strong>
                {{ 'SIGNER.SIGNS' | translate }}
              </ng-container>
              <ng-container *ngIf="documentos && !documentos.signatures"> <strong>0</strong> {{ 'SIGNER.SIGNS' | translate }} </ng-container>
              <ng-container *ngIf="documentos && documentos.authorization && documentos.signatures">
                {{ 'SIGNER.AND' | translate }}
              </ng-container>
              <ng-container *ngIf="documentos && documentos.authorization">
                <strong>{{ documentos.authorization.length }}</strong>
                {{ 'SIGNER.AUTHORIZATIONS' | translate }}
              </ng-container>
              <ng-container *ngIf="documentos && !documentos.authorization"> <strong>0</strong> {{ 'SIGNER.AUTHORIZATIONS' | translate }} </ng-container>
              {{ 'SIGNER.FOR_REVIEW' | translate }}
            </p>
          </div>
          <!-- Bloque autorizaciones. -->
          <div *ngIf="documentos && documentos.authorization" class="pb-4">
            <!-- Título del bloque. -->
            <h3 class="text-center mb-4">
              {{ 'SIGNER.MAYUS_AUTHORIZATIONS' | translate }}
              <!-- Contador de autorizaciones.  -->
              <span class="badge badge-primary">
                {{ documentos.authorization.length }}
              </span>
            </h3>
            <!-- Autorizaciones.  -->
            <div *ngFor="let authorization of documentos.authorization; let i = index">
              <!-- Cabecera del acordeon.  -->
              <a class="text-left" (click)="ocultarTabsetss(authorization.authorizationId)">
                <div class="list-element">
                  <ng-container *ngIf="authorization['title']">
                    {{ authorization.title }}
                  </ng-container>
                  <em *ngIf="!authorization['title']">
                    {{ 'SIGNER.WITHOUT_TITTLE' | translate }}
                  </em>
                  <div>
                    <!-- Campo requerido.  -->
                    <span *ngIf="authorization['requiredAuthentication']" class="badge badge-warning ml-2">
                      {{ 'MANDATORY_FIELDS' | translate }}
                    </span>
                    <i *ngIf="authorization['visible'] === true" class="fa-thin fa-chevron-up fa-x2 iconsize quiter-color ml-2"></i>
                    <i *ngIf="authorization['visible'] === false" class="fa-thin fa-chevron-down fa-x2 iconsizequiter-color ml-2"></i>
                  </div>
                </div>
              </a>
              <!-- Contenido del acordeon. -->
              <div id="{{ authorization.authorizationId }}" class="panel-collapse" [ngClass]="{ collapse: !authorization.requiredAuthentication }">
                <!-- Tipos de componentes (5 tipos posibles) -->
                <div [ngSwitch]="authorization.authorizationType" id="authorization.authorizationId">
                  <!-- Tipo 1: si o no. devuelvo lo que me llegue en el fixed value -->
                  <ng-container *ngSwitchCase="1">
                    <div id="tab-{{ authorization.authorizationId }}" #info class="row form-group">
                      <!-- Etiqueta. -->
                      <div class="d-flex justify-content-between">
                        <label class="text-left col-form-label">
                          {{ authorization.authorizationText }}
                        </label>
                        <!-- Clear button.  -->
                        <button
                          *ngIf="model[authorization.authorizationId]"
                          class="btn btn-outline-danger btn-noborder"
                          type="button"
                          id="button-borrar{{ authorization.authorizationId }}"
                          (click)="borrarAuthorization('radio-' + authorization.authorizationId)"
                        >
                          <i class="fa-thin fa-undo"></i>
                        </button>
                      </div>
                      <!-- True.  -->
                      <div class="col-12">
                        <label>
                          <input
                            id="radio-{{ authorization.authorizationId }}-true"
                            type="radio"
                            class="radiobtn form-radio"
                            name="radio{{ authorization.authorizationId }}-true"
                            value="true"
                            [(ngModel)]="model[authorization.authorizationId]"
                            (change)="requireFields()"
                          />
                          <span>{{ 'SIGNER.YES' | translate }}</span>
                        </label>
                      </div>
                      <!-- False.  -->
                      <div class="col-12">
                        <label>
                          <input
                            id="radio-{{ authorization.authorizationId }}-false"
                            type="radio"
                            class="radiobtn form-radio"
                            name="radio{{ authorization.authorizationId }}-false"
                            value="false"
                            [(ngModel)]="model[authorization.authorizationId]"
                            (change)="requireFields()"
                          />
                          <span>{{ 'SIGNER.NO' | translate }}</span>
                        </label>
                      </div>
                    </div>
                  </ng-container>

                  <!-- Tipo 2: Text area -->
                  <ng-container *ngSwitchCase="2">
                    <div id="tab-{{ authorization.authorizationId }}" #info>
                      <!-- Etiqueta. -->
                      <div class="d-flex justify-content-between">
                        <label class="text-left col-form-label">
                          {{ authorization.authorizationText }}
                        </label>
                        <!-- Clear button.  -->
                        <button
                          *ngIf="model[authorization.authorizationId]"
                          class="btn btn-outline-danger btn-noborder"
                          type="button"
                          id="button-borrar{{ authorization.authorizationId }}"
                          (click)="borrarAuthorization('textarea-' + authorization.authorizationId)"
                        >
                          <i class="fa-thin fa-undo"></i>
                        </button>
                      </div>
                      <!-- Textarea.  -->
                      <textarea
                        id="textarea-{{ authorization.authorizationId }}"
                        [(ngModel)]="model[authorization.authorizationId]"
                        class="form-control textarea-width m-b"
                        rows="3"
                        (change)="requireFields()"
                      ></textarea>
                    </div>
                  </ng-container>

                  <!-- Tipo 3: Ranking (estrellas) de 0 a 5 -->
                  <ng-container *ngSwitchCase="3">
                    <!-- Etiqueta. -->
                    <div class="d-flex justify-content-between">
                      <label class="text-left col-form-label">
                        {{ authorization.authorizationText }}
                      </label>
                      <!-- Clear button. -->
                      <button
                        *ngIf="model[authorization.authorizationId]"
                        class="btn btn-outline-danger btn-noborder"
                        type="button"
                        id="button-borrar{{ authorization.authorizationId }}"
                        (click)="borrarAuthorization('rating-' + authorization.authorizationId)"
                      >
                        <i class="fa-thin fa-undo"></i>
                      </button>
                    </div>
                    <!-- Bar rating.  -->
                    <div class="col-12">
                      <bar-rating
                        id="rating-{{ authorization.authorizationId }}"
                        [(ngModel)]="model[authorization.authorizationId]"
                        [max]="5"
                        (change)="requireFields()"
                      ></bar-rating>
                    </div>
                  </ng-container>

                  <!-- Tipo 4: Fecha -->
                  <ng-container #info *ngSwitchCase="4">
                    <div id="tab-{{ authorization.authorizationId }}" #info>
                      <!-- Etiqueta. -->
                      <div class="d-flex justify-content-between">
                        <label class="text-left col-form-label">
                          {{ authorization.authorizationText }}
                        </label>
                        <!-- Clear button. -->
                        <button
                          *ngIf="model[authorization.authorizationId]"
                          class="btn btn-outline-danger btn-noborder"
                          type="button"
                          id="button-borrar{{ authorization.authorizationId }}"
                          (click)="borrarAuthorization('datePicker-' + authorization.authorizationId)"
                        >
                          <i class="fa-thin fa-undo"></i>
                        </button>
                      </div>
                      <!-- Fecha.  -->
                      <div class="col-xs-offset-1">
                        <input
                          [(ngModel)]="model[authorization.authorizationId]"
                          type="text"
                          placeholder="Seleccione una fecha"
                          class="form-control m-b-lg"
                          bsDatepicker
                          id="datePicker-{{ authorization.authorizationId }}"
                          (change)="requireFields()"
                        />
                      </div>
                    </div>
                  </ng-container>

                  <!-- Tipo 5: Combo -->
                  <ng-container *ngSwitchCase="5">
                    <div id="tab-{{ authorization.authorizationId }}" #info>
                      <!-- Etiqueta. -->
                      <div class="d-flex justify-content-between">
                        <label class="text-left col-form-label">
                          {{ authorization.authorizationText }}
                        </label>
                        <!-- Clear button. -->
                        <button
                          *ngIf="model[authorization.authorizationId]"
                          class="btn btn-outline-danger btn-noborder"
                          type="button"
                          id="button-borrar{{ authorization.authorizationId }}"
                          (click)="borrarAuthorization('dropdown-' + authorization.authorizationId)"
                        >
                          <i class="fa-thin fa-undo"></i>
                        </button>
                      </div>
                      <!-- Options.  -->
                      <div class="col-xs-offset-1">
                        <select
                          [(ngModel)]="model[authorization.authorizationId]"
                          class="form-control m-b-lg"
                          id="dropdown-{{ authorization.authorizationId }}"
                          (change)="requireFields()"
                        >
                          <option [ngValue]="undefined" disabled selected>
                            {{ 'SIGNER.SELECT_OPTION' | translate }}
                          </option>
                          <option *ngFor="let item of authorization.fixedValue" value="{{ item }}">
                            {{ item }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </ng-container>

                  <!-- Tipo 6: Checks con opción multiple -->
                  <ng-container *ngSwitchCase="6">
                    <!-- Opportunity status selector -->
                    <div id="tab-{{ authorization.authorizationId }}" #info class="row form-group">
                      <!-- Etiqueta. -->
                      <div class="d-flex justify-content-between">
                        <label class="text-left col-form-label">
                          {{ authorization.authorizationText }}
                        </label>
                        <!-- Clear button. -->
                        <button
                          *ngIf="model['checkbox-data']"
                          class="btn btn-outline-danger btn-noborder"
                          type="button"
                          id="button-borrar{{ authorization.authorizationId }}+'-'+h"
                          (click)="borrarAuthorization('checkbox-' + authorization.authorizationId)"
                        >
                          <i class="fa-thin fa-undo"></i>
                        </button>
                      </div>
                      <!-- Checkbox.  -->
                      <div #checkbox id="checkbox-{{ authorization.authorizationId }}">
                        <div *ngFor="let menuItem of authorization.fixedValue; let j = index" class="col-12">
                          <input
                            [(ngModel)]="model['checkbox-' + authorization.authorizationId + '-' + menuItem]"
                            type="checkbox"
                            value="{{ menuItem }}"
                            id="checkbox-{{ authorization.authorizationId }}-{{ menuItem }}"
                            (change)="requireFields()"
                            (ngModelChange)="
                              changeCheckBox($event, 'checkbox-' + authorization.authorizationId + '-' + menuItem, 'checkbox-' + authorization.authorizationId + menuItem)
                            "
                          />
                          <label class="form-check-label" for="checkbox-{{ authorization.authorizationId }}-{{ menuItem }}">
                            {{ menuItem }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>

          <!-- Bloque firmas. -->
          <div *ngIf="documentos && documentos.signatures">
            <!-- Título del bloque. -->
            <h3 class="text-center mb-4">
              {{ 'SIGNER.SIGNS' | translate }}
              <!-- Contador de firmas.  -->
              <span class="badge badge-pill badge-primary">
                {{ documentos.signatures.length }}
              </span>
            </h3>
            <!-- Firmas. -->
            <div *ngFor="let signature of documentos['signatures']; let i = index">
              <!-- Cabecera del acordeon.  -->
              <a class="text-left" (click)="ocultarSignatures($event, signature['signatureId'])">
                <!-- Title  -->
                <div class="list-element">
                  <ng-container *ngIf="signature['text']"> {{ htmlDecode(signature.text) }}</ng-container>
                  <div>
                    <!-- Campo requerido.  -->
                    <span *ngIf="signature['required']" class="badge badge-warning ml-2">
                      {{ 'MANDATORY_FIELDS' | translate }}
                    </span>
                    <i *ngIf="signature['visible'] === true" class="fa-thin fa-chevron-up fa-x2 iconsize quiter-color ml-2"></i>
                    <i *ngIf="signature['visible'] === false" class="fa-thin fa-chevron-down fa-x2 iconsize quiter-color ml-2"></i>
                  </div>
                </div>
              </a>
              <!-- Contenido del acordeon. -->
              <div [ngClass]="{ oculto: !signature['visible'] }">
                <div id="{{ signature['signatureId'] }}" class="panel-collapse">
                  <canvas
                    class="signature-component"
                    ejs-signature
                    #signature
                    id="sig-{{ signature['signatureId'] }}"
                    (change)="changeSignature('sig-' + signature['signatureId'])"
                  ></canvas>
                  <!-- Botón borrar firma del componente.  -->

                  <button
                    id="button-signature-{{ signature['signatureId'] }}"
                    class="btn btn-outline-danger btn-noborder btn-signature"
                    type="button"
                    *ngIf="signature['btnVisible']"
                    (click)="clearSignatureComponentById('sig-' + signature['signatureId'])"
                  >
                    <i class="fa-thin fa-eraser mr-1"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Botonera. -->
  <div class="row text-center" class="mt-4 mb-4">
    <div class="text-center" style="margin-left: auto; margin-right: auto">
      <!-- Botón enviar.  -->
      <button
        [disabled]="btnSendData"
        type="button"
        class="btn btn-primary"
        (click)="sendData()"
        [ngStyle]="{ 'pointer-events': !blockbuttonSend === true ? 'none' : 'auto', opacity: !blockbuttonSend === true ? '0.4' : '1' }"
      >
        <!-- Icono enviar.  -->
        <span *ngIf="!ButtonSendingInfo">
          {{ 'SIGNER.SEND' | translate }}
        </span>
        <!-- Icono enviando.  -->
        <span *ngIf="ButtonSendingInfo">
          <i class="fa fa-spinner fa-spin"></i>
          {{ 'SIGNER.SENDING_INFO' | translate }}
        </span>
      </button>
    </div>
  </div>
</div>
